<template>
  <div>
    <!-- 退款弹窗 -->
    <a-modal title="退款" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div class="refundBox">
        <span class="cr-mr-1 cr-text-black-1">退款原因:</span>
        <textarea class="reason cr-p-1 cr-fs-md" v-model="value" placeholder="请输入转交原因，以便相关人员知悉"></textarea>
      </div>
      <template slot="footer">
        <span class="cr-fs-md cr-text-grey-1 cr-mr-1">* 退款申请通过后将为您退款</span>
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="handleOk"> 确定 </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { applyRefund } from '@/api/common'
export default {
  name: 'CaseRefund',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    case: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    //确定
    async handleOk() {
      const res = await applyRefund({
        batchNo: this.case.caseNo,
        operatorId: this.$store.getters.userInfo.userId,
        refOrder: this.case.caseNo,
        refundAmount: this.case.amount,
        refundReason: this.value,
        refundType: 2,
        remark: '版权工作台案件管理申请退款'
      })
      if (res.code == 0) {
        this.$message.success('申请成功！')
        this.$emit('refresh')
        this.handleCancel()
      }
    },
    //取消
    handleCancel() {
      this.value = ''
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-modal-content {
  width: 540px;
  height: 298px;
  .ant-modal-title {
    font-weight: 500;
  }
}
.refundBox {
  .reason {
    vertical-align: top;
    width: 412px;
    height: 140px;
    outline: none;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
  }
  textarea::input-placeholder {
    color: #999;
  }
  textarea::-webkit-input-placeholder {
    //兼容WebKit browsers（Chrome的内核）
    color: #999;
  }
  textarea::-moz-placeholder {
    //Mozilla Firefox 4 to 18
    color: #999;
  }
  textarea::-moz-placeholder {
    //Mozilla Firefox 19+
    color: #999;
  }
  textarea::-ms-input-placeholder {
    //Internet Explorer 10+
    color: #999;
  }
}
</style>
